import {
  SEARCH_SUGGESTED_PRODUCTS,
  SEARCH_SUGGESTED_PRODUCTS_SUCCESS,
  SEARCH_SUGGESTED_PRODUCTS_ERROR,
  CREATE_SUGGESTED_PRODUCT,
  CREATE_SUGGESTED_PRODUCT_SUCCESS,
  CREATE_SUGGESTED_PRODUCT_ERROR,
  UPDATE_SUGGESTED_PRODUCT,
  UPDATE_SUGGESTED_PRODUCT_SUCCESS,
  UPDATE_SUGGESTED_PRODUCT_ERROR,
  DELETE_SUGGESTED_PRODUCT,
  DELETE_SUGGESTED_PRODUCT_SUCCESS,
  DELETE_SUGGESTED_PRODUCT_ERROR,
  CLEAR_SUGGESTED_PRODUCT_STATE,
  SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT,
  SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_SUCCESS,
  SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_ERROR,
  GET_SPECIALTIES,
  GET_SPECIALTIES_SUCCESS,
  GET_SPECIALTIES_ERROR,
} from '../constants/ActionsTypes'

export const searchSuggestedProducts = (params) => ({
  type: SEARCH_SUGGESTED_PRODUCTS,
  payload: params,
})

export const searchSuggestedProductsSuccess = (data) => ({
  type: SEARCH_SUGGESTED_PRODUCTS_SUCCESS,
  payload: data,
})

export const searchSuggestedProductsError = (error) => ({
  type: SEARCH_SUGGESTED_PRODUCTS_ERROR,
  payload: error,
})

export const createSuggestedProduct = (params) => ({
  type: CREATE_SUGGESTED_PRODUCT,
  payload: params,
})

export const createSuggestedProductSuccess = (data) => ({
  type: CREATE_SUGGESTED_PRODUCT_SUCCESS,
  payload: data,
})

export const createSuggestedProductError = (error) => ({
  type: CREATE_SUGGESTED_PRODUCT_ERROR,
  payload: error,
})

export const updateSuggestedProduct = (params) => ({
  type: UPDATE_SUGGESTED_PRODUCT,
  payload: params,
})

export const updateSuggestedProductSuccess = (data) => ({
  type: UPDATE_SUGGESTED_PRODUCT_SUCCESS,
  payload: data,
})

export const updateSuggestedProductError = (error) => ({
  type: UPDATE_SUGGESTED_PRODUCT_ERROR,
  payload: error,
})

export const deleteSuggestedProduct = (id) => ({
  type: DELETE_SUGGESTED_PRODUCT,
  payload: id,
})

export const deleteSuggestedProductSuccess = (data) => ({
  type: DELETE_SUGGESTED_PRODUCT_SUCCESS,
  payload: data,
})

export const deleteSuggestedProductError = (error) => ({
  type: DELETE_SUGGESTED_PRODUCT_ERROR,
  payload: error,
})

export const clearSuggestedProductState = () => ({
  type: CLEAR_SUGGESTED_PRODUCT_STATE,
})

export const searchSuggestedProductsByClient = (params) => ({
  type: SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT,
  payload: params,
})

export const searchSuggestedProductsByClientSuccess = (data, displayLocation) => ({
  type: SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_SUCCESS,
  payload: data,
  displayLocation,
})

export const searchSuggestedProductsByClientError = (error, displayLocation) => ({
  type: SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_ERROR,
  payload: error,
  displayLocation,
})

export const getSpecialties = () => ({
  type: GET_SPECIALTIES,
})

export const getSpecialtiesSuccess = (data) => ({
  type: GET_SPECIALTIES_SUCCESS,
  payload: data,
})

export const getSpecialtiesError = (error) => ({
  type: GET_SPECIALTIES_ERROR,
  payload: error,
})
